import React from 'react';
import { PropTypes } from 'prop-types';
import { MetaData } from 'components/project/ClerkScreen';
import { StyledMessage, MessageText } from './Styles';
import { OnlineIndicator } from '../OnlineIndicator/index';
import { messagePrettier } from './../../../../../stores/utils';
import { LONGEST_VIN_LENGTH } from 'shared/constants';


const BidderMessage = ({
  children,
  itemNumber,
  user,
  timestamp,
  onReplyClick,
  handleMetaDataClick,
  isSeller,
  zoomLevel,
  chatFontSize,
}) => {
  return (
    <StyledMessage isSeller={isSeller}>
      <MessageText
        isSeller={isSeller}
        zoomLevel={zoomLevel}
        chatFontSize={chatFontSize}
      >
        <div>
          <OnlineIndicator user={user} />
        </div>
        <div>
          {messagePrettier(children, LONGEST_VIN_LENGTH)}
        </div>
      </MessageText>
      <MetaData
        itemNumber={itemNumber}
        timestamp={timestamp}
        onReplyClick={onReplyClick}
        handleMetaDataClick={handleMetaDataClick}
        chatFontSize={chatFontSize}
      />
    </StyledMessage>
  );
};

BidderMessage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  itemNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  user: PropTypes.string,
  timestamp: PropTypes.string,
  onReplyClick: PropTypes.func.isRequired,
  handleMetaDataClick: PropTypes.func.isRequired,
  isSeller: PropTypes.bool,
};

BidderMessage.defaultProps = {
  children: null,
  itemNumber: null,
  user: null,
  timestamp: null,
  isSeller: false,
};
export default BidderMessage;
